import React from 'react';
import { withTranslation } from 'react-i18next';
import Person from '../../objects/Person';
import { AccordionWrapper } from 'react-lib/dist/components-es';
import PersonListContainer from '../common/PersonListContainer';

class BBuildingContactPersonListContainer extends React.Component {
  render() {
    return (
      <AccordionWrapper
        {...this.props}
        closable={false}
        accordionTitle="building.summary.page.building.contact.person.list.container.title"
        render={this.getContainerBody}
        className="containerReducedWhiteSpace"
      />
    );
  }

  getContainerBody = () => {
    if (this.props.values.buildingContactPersons == null)
      this.props.values.buildingContactPersons = [];
    return (
      <PersonListContainer
        {...this.props}
        newPersonEntity={Person}
        arrayPropName="buildingContactPersons"
        showEmailHandler={true}
        showNoEmailAvailable={true}
        showRole={true}
      />
    );
  };
}

export default withTranslation()(BBuildingContactPersonListContainer);
